import { useClinicalProtocolsEnabled } from '@/hooks/useClinicalProtocolsEnabled';
import { ProtocolIndex } from '@/pages/ProtocolViewer/ProtocolIndex';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // Same gate as the picker: the protocols are experimental and several of their citations are not
  // yet verified, so the viewer is internal until they are.
  if (!useClinicalProtocolsEnabled()) return null;
  return <ProtocolIndex />;
};

export const Route = createFileRoute('/_auth/internal/protocols/')({ component: RouteComponent });
